var $4BZbJ$uuid = require("uuid");


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$export(module.exports, "renderFieldsForTokenization", () => $597ed8cd77b80d65$export$214cd789bf36dbe8);
$parcel$export(module.exports, "renderFields", () => $597ed8cd77b80d65$export$1b4461fdcf0903a6);


const $f1278d2a22b681dd$export$7d576a40358207c0 = [
    "cvv",
    "expirationDate",
    "cardNumber"
];
var $f1278d2a22b681dd$export$bdb47a4f704771fb = /*#__PURE__*/ function(GlobalPostMessageEventKind) {
    GlobalPostMessageEventKind["PAYMENT_CARD_FETCH_ERROR"] = "PAYMENT_CARD_FETCH_ERROR";
    GlobalPostMessageEventKind["PAYMENT_CARD_FETCH_SUCCESS"] = "PAYMENT_CARD_FETCH_SUCCESS";
    // Input/configuration error kind
    GlobalPostMessageEventKind["CARD_VIEWER_INPUT_ERROR"] = "CARD_VIEWER_INPUT_ERROR";
    GlobalPostMessageEventKind["INVALID_CREDENTIAL_ERROR"] = "INVALID_CREDENTIAL_ERROR";
    GlobalPostMessageEventKind["GENERIC_ERROR"] = "GENERIC_ERROR";
    GlobalPostMessageEventKind["TOGGLE_CARD_NUMBER_MASK"] = "TOGGLE_CARD_NUMBER_MASK";
    GlobalPostMessageEventKind["COPY_TO_CLIPBOARD_ERROR"] = "COPY_TO_CLIPBOARD_ERROR";
    GlobalPostMessageEventKind["COPY_TO_CLIPBOARD_SUCCESS"] = "COPY_TO_CLIPBOARD_SUCCESS";
    GlobalPostMessageEventKind["CARD_VIEWER_READY"] = "CARD_VIEWER_READY";
    return GlobalPostMessageEventKind;
}({});


// -- Secure channel handshake protocol (DX-8174 / DX-8205) -------------------
// Shared by every Highnote SDK that delivers credentials to a hosted iframe
// without placing them in the iframe URL (browser history/sync, web archives,
// CDN/proxy logs, analytics scripts reading location.href). The SDK posts
// HANDSHAKE_INIT to the iframe on frame `load` (transferring one MessagePort),
// the iframe replies HANDSHAKE_ACK on that port, and the SDK then delivers
// credentials in a CONFIGURE message over the same private port.
//
// This module lives in @highnoteplatform/types — not @highnoteplatform/iframes —
// deliberately: the published SDKs' parcel builds bundle ONLY this package
// (targets.*.includeNodeModules allowlist, built with --no-scope-hoist, i.e. no
// tree-shaking), so importing the iframes package here would drag its entire
// re-export graph into the public SDK bundles. Do not "tidy" this into iframes.
const $9811ef52d0caa509$export$bdf67dc867af0994 = "SECURE_CHANNEL_HANDSHAKE_INIT";
const $9811ef52d0caa509$export$21b7abb723f51b7e = "SECURE_CHANNEL_HANDSHAKE_ACK";
const $9811ef52d0caa509$export$46fb7dfe3495e1c = "SECURE_CHANNEL_CONFIGURE";
const $9811ef52d0caa509$export$9941bb4ec5193584 = 10000;
const $9811ef52d0caa509$export$ca4bc7545e4f4a8d = 15000;
const $9811ef52d0caa509$export$b5130285aa45b350 = (data, typename)=>typeof data === "object" && data !== null && "__typename" in data && data.__typename === typename;
const $9811ef52d0caa509$export$84683bda827d284f = ({ frame: frame, iframeOrigin: iframeOrigin, uuid: uuid, clientToken: clientToken, paymentCardId: paymentCardId, sdkName: sdkName, sdkVersion: sdkVersion, onFailure: onFailure, onHandshakeAck: onHandshakeAck, timeoutMs: timeoutMs = $9811ef52d0caa509$export$9941bb4ec5193584 })=>{
    let disposed = false;
    let failed = false;
    let cleanupPending;
    // onFailure is one-shot for the channel's lifetime. A frame can emit `load`
    // more than once (reload), and both the FRAME_UNREACHABLE and
    // HANDSHAKE_TIMEOUT paths can be reached again on a subsequent load — the
    // integrator must not be re-notified of the same failed handshake, nor
    // receive a failure after an earlier one already fired.
    const reportFailure = (failure)=>{
        if (failed) return;
        failed = true;
        onFailure(failure);
    };
    const onLoad = ()=>{
        // A reloaded frame is a fresh document with a fresh listener; tear down
        // the previous channel so its timeout cannot fire a spurious error.
        cleanupPending?.();
        cleanupPending = undefined;
        const targetWindow = frame.contentWindow;
        if (targetWindow === null) {
            reportFailure("FRAME_UNREACHABLE");
            return;
        }
        const channel = new MessageChannel();
        const sdkPort = channel.port1;
        const timeout = setTimeout(()=>{
            sdkPort.close();
            cleanupPending = undefined;
            reportFailure("HANDSHAKE_TIMEOUT");
        }, timeoutMs);
        cleanupPending = ()=>{
            clearTimeout(timeout);
            sdkPort.close();
        };
        sdkPort.onmessage = (event)=>{
            if (!$9811ef52d0caa509$export$b5130285aa45b350(event.data, $9811ef52d0caa509$export$21b7abb723f51b7e)) return;
            clearTimeout(timeout);
            onHandshakeAck?.();
            const configure = {
                __typename: $9811ef52d0caa509$export$46fb7dfe3495e1c,
                clientToken: clientToken,
                ...paymentCardId === undefined ? {} : {
                    paymentCardId: paymentCardId
                },
                ...sdkName === undefined ? {} : {
                    sdkName: sdkName
                },
                ...sdkVersion === undefined ? {} : {
                    sdkVersion: sdkVersion
                }
            };
            sdkPort.postMessage(configure);
            // CONFIGURE is the last message on this channel; the iframe closes its
            // end on receipt. Close ours too for lifecycle symmetry — the message
            // is already queued on the peer, so closing here does not drop it.
            // (cleanupPending is left as-is; the disposer's close() is idempotent.)
            sdkPort.close();
        };
        const init = {
            __typename: $9811ef52d0caa509$export$bdf67dc867af0994,
            uuid: uuid
        };
        targetWindow.postMessage(init, iframeOrigin, [
            channel.port2
        ]);
    };
    frame.addEventListener("load", onLoad);
    return ()=>{
        if (disposed) return;
        disposed = true;
        frame.removeEventListener("load", onLoad);
        cleanupPending?.();
        cleanupPending = undefined;
    };
};
const $9811ef52d0caa509$export$d572882ed38b887b = ()=>{
    let settled = false; // one handshake-phase error already surfaced
    let configurePhase = false; // ACK received -> iframe is sole authority
    return {
        ack: ()=>{
            configurePhase = true;
        },
        wrapFailure: (deliver)=>(e)=>{
                if (settled) return;
                settled = true;
                deliver(e);
            },
        wrapRelay: (deliver)=>(e)=>{
                if (configurePhase) {
                    deliver(e); // post-ACK: pass every relayed error unconditionally
                    return;
                }
                if (settled) return; // pre-ACK duplicate: swallow
                settled = true;
                deliver(e);
            }
    };
};


const $e4bfc9dfdbfc25a2$export$1ec34c2c9b231c0f = [
    "pin",
    "cardNumber",
    "expirationMonth",
    "expirationYear",
    "expirationDate",
    "securityCode"
];
const $e4bfc9dfdbfc25a2$export$2db53370b14e73a1 = [
    "visa",
    "mastercard",
    "amex",
    "discover"
];
var $e4bfc9dfdbfc25a2$export$5278e3e6401288b4 = /*#__PURE__*/ function(SecureInputsGlobalPostMessageEventKind) {
    SecureInputsGlobalPostMessageEventKind["GENERIC_ERROR"] = "GENERIC_ERROR";
    SecureInputsGlobalPostMessageEventKind["INVALID_CREDENTIAL_ERROR"] = "INVALID_CREDENTIAL_ERROR";
    SecureInputsGlobalPostMessageEventKind["USER_INPUT_ERROR"] = "USER_INPUT_ERROR";
    SecureInputsGlobalPostMessageEventKind["REQUEST_ERROR"] = "REQUEST_ERROR";
    SecureInputsGlobalPostMessageEventKind["ON_INPUT"] = "ON_INPUT";
    SecureInputsGlobalPostMessageEventKind["ON_SUBMIT"] = "ON_SUBMIT";
    SecureInputsGlobalPostMessageEventKind["CHANGE_CARD_PIN"] = "CHANGE_CARD_PIN";
    SecureInputsGlobalPostMessageEventKind["TOKENIZE_CARD"] = "TOKENIZE_CARD";
    SecureInputsGlobalPostMessageEventKind["ON_CARD_INPUT"] = "ON_CARD_INPUT";
    SecureInputsGlobalPostMessageEventKind["ON_PIN_CHANGE_SUCCESS"] = "ON_PIN_CHANGE_SUCCESS";
    SecureInputsGlobalPostMessageEventKind["ON_TOKENIZE_CARD_SUCCESS"] = "ON_TOKENIZE_CARD_SUCCESS";
    SecureInputsGlobalPostMessageEventKind["ON_STATE_CHANGE"] = "ON_STATE_CHANGE";
    SecureInputsGlobalPostMessageEventKind["ON_READY"] = "ON_READY";
    SecureInputsGlobalPostMessageEventKind["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    return SecureInputsGlobalPostMessageEventKind;
}({});






var $b93b2f10d012197d$export$c278f139ce6eedba = /*#__PURE__*/ function(CheckoutPostMessageKind) {
    CheckoutPostMessageKind["TOKENIZE_SUCCCESS"] = "TOKENIZE_SUCCCESS";
    CheckoutPostMessageKind["TOKENIZE_ERROR"] = "TOKENIZE_ERROR";
    CheckoutPostMessageKind["CHECKOUT_READY"] = "CHECKOUT_READY";
    return CheckoutPostMessageKind;
}({});
class $b93b2f10d012197d$export$4e94f40711c15818 extends Error {
    constructor(message, errors){
        super(message), this.name = "CheckoutConfigInputError";
        this.errors = errors;
    }
}
const $b93b2f10d012197d$export$e65600b7ad68fd67 = [
    "Pay",
    "Submit"
];


// Descriptive SDK identity for the `x-highnote-sdk` adoption-telemetry header
// (`<name>/<version>`). Lives in @highnoteplatform/types because that is the
// only package bundled into every public SDK's parcel build (see
// secureChannel.ts) — the one bundle-safe shared home.
//
// HOW TO INSTRUMENT A NEW SDK
// 1. In the SDK package, import its own package.json name + version:
//        import { name, version } from "../package.json";
// 2. Build the identity so `name` can't drift from the published package name:
//        const SDK = sdkIdentityFromPackage({ name, version });
// 3. Page-context SDK: pass SDK as the 3rd arg to `highnoteClient(...)`, behind a
//    small `xxxClient` factory (see documentUploadClient / riskApplicationClient).
//    Iframe SDK: reuse SDK.name for BOTH the CDN path segment and the
//    secure-channel handshake `sdkName` (see card-viewer/secure-inputs
//    config.ts + handshake.ts) so telemetry and CDN can't desync.
const $d81fcc39b2ce6889$var$SCOPE_PREFIX = /^@highnoteplatform\//;
const $d81fcc39b2ce6889$export$3ddec0068072ba94 = (pkg)=>({
        name: pkg.name.replace($d81fcc39b2ce6889$var$SCOPE_PREFIX, ""),
        version: pkg.version
    });


const $8b57b3c8ac20b6a1$export$8acf5617026d4b16 = [
    "borderRadius",
    "backgroundColor",
    "color",
    "cursor",
    "fontFamily",
    "fontSize",
    "fontWeight",
    "letterSpacing",
    "lineHeight",
    "userSelect",
    "border"
];
const $8b57b3c8ac20b6a1$export$93b12edf1b0f1762 = [
    ":focus",
    ":hover",
    ":invalid",
    ":valid"
];
const $8b57b3c8ac20b6a1$export$679b0194e2408a3e = [
    "live",
    "test"
];




var $d43ef53dcb67a92a$exports = {};
$d43ef53dcb67a92a$exports = JSON.parse("{\"name\":\"@highnoteplatform/secure-inputs\",\"version\":\"1.10.0\",\"description\":\"Secure input fields for your customer.\",\"source\":\"src/index.ts\",\"access\":\"public\",\"main\":\"lib/index.js\",\"module\":\"lib/esm/module.js\",\"types\":\"lib/types.d.ts\",\"files\":[\"lib\",\"README.md\"],\"scripts\":{\"clean\":\"rimraf lib dist\",\"prebuild\":\"npm run clean\",\"build\":\"PARCEL_WORKER_BACKEND=process parcel build --detailed-report --no-scope-hoist --no-cache\",\"postbuild\":\"node ../../scripts/fix-node-env.js\",\"prepublishOnly\":\"npm run build\",\"test\":\"jest\",\"test:watch\":\"jest --watch\",\"prepack\":\"npm run build\",\"predev\":\"node ../../scripts/clean-build-output.js lib dist\",\"dev\":\"parcel watch --port 3005 --hmr-port 2005 --no-cache --dist-dir=lib\"},\"author\":\"packages@highnote.com\",\"license\":\"MIT\",\"homepage\":\"https://highnote.com\",\"devDependencies\":{\"@highnoteplatform/types\":\"*\",\"@types/jest\":\"28.1.8\",\"@types/uuid\":\"^9.0.1\",\"@types/jsdom\":\"21.1.1\",\"@types/node\":\"^22.0.0\",\"eslint-plugin-jest\":\"27.2.1\",\"jest\":\"^28.1.3\",\"jest-environment-jsdom\":\"^29.5.0\",\"jsdom\":\"21.1.1\",\"ts-jest\":\"28.0.8\"},\"targets\":{\"main\":{\"includeNodeModules\":[\"@highnoteplatform/types\"],\"optimize\":true},\"module\":{\"includeNodeModules\":[\"@highnoteplatform/types\"],\"optimize\":true}},\"dependencies\":{\"uuid\":\"^11.0.0\"}}");


const { SECURE_INPUTS_IFRAME_PORT: $219e08b0dbf8e45a$var$SECURE_INPUTS_IFRAME_PORT = 3006 } = process.env;
const $219e08b0dbf8e45a$var$identity = (0, $d81fcc39b2ce6889$export$3ddec0068072ba94)({
    name: $d43ef53dcb67a92a$exports.name,
    version: $d43ef53dcb67a92a$exports.version
});
const $219e08b0dbf8e45a$export$9345d7360ffe0722 = $219e08b0dbf8e45a$var$identity.name;
const $219e08b0dbf8e45a$export$91546b032799aa40 = $219e08b0dbf8e45a$var$identity.version;
const $219e08b0dbf8e45a$export$f76cea9319723dd2 = process.env.NODE_ENV === "production" ? "https://cdn.highnote.com" : `http://localhost:${$219e08b0dbf8e45a$var$SECURE_INPUTS_IFRAME_PORT}`;
// NOTE: the production iframe bundle is fetched from a fixed CDN path segment
// ("secure-inputs") that MUST match the deploy pipeline's hardcoded app name
// (publish-release.yml `matrix.app`) — keep it a literal, never derived, so a
// package.json rename can't point the fetch at an undeployed path. The version
// segment keys the bundle to THIS package's version: a release that changes
// secure-inputs-iframes without bumping @highnoteplatform/secure-inputs would
// overwrite an already-deployed bundle in place — always version them together.
// The telemetry sdkName (handshake.ts) IS derived from the package name via
// packageName; handshake.test.ts asserts sdkName === "secure-inputs", which pins
// packageName to this same literal so the telemetry label and CDN segment
// cannot silently desync.
const $219e08b0dbf8e45a$var$iframePath = (apiEnvironment)=>{
    let path = "";
    if (process.env.NODE_ENV === "production") path = `secure-inputs/${$219e08b0dbf8e45a$export$91546b032799aa40}/`;
    return apiEnvironment === "test" ? `${path}index_test.html` : `${path}index.html`;
};
const $219e08b0dbf8e45a$export$1c3aefb711c3a4cc = ()=>(0, $4BZbJ$uuid.v4)();
const $219e08b0dbf8e45a$export$f7872bdb68630f49 = (apiEnvironment)=>`${$219e08b0dbf8e45a$export$f76cea9319723dd2}/${$219e08b0dbf8e45a$var$iframePath(apiEnvironment)}`;


const $35c611973a530206$var$buildFrameSource = (config)=>{
    const { elementConfig: elementConfigMap, field: field, environment: environment, uuid: uuid, fields: fields, excludedCardBrands: excludedCardBrands = [] } = config;
    const { styles: styles } = elementConfigMap[field] ?? {};
    const searchParameters = new URLSearchParams();
    searchParameters.set("field", field);
    searchParameters.set("environment", environment);
    searchParameters.set("fields", fields.join("|"));
    searchParameters.set("styles", JSON.stringify(styles ?? {}));
    searchParameters.set("excludedCardBrands", excludedCardBrands.join("|"));
    switch(field){
        case "pin":
            {
                const { masked: masked = false, showToggle: showToggle = false } = elementConfigMap.pin ?? {};
                searchParameters.set("masked", String(masked));
                searchParameters.set("showToggle", String(showToggle));
                break;
            }
        default:
            break;
    }
    const frameSource = new URL(`${(0, $219e08b0dbf8e45a$export$f7872bdb68630f49)(environment)}?${searchParameters.toString()}`);
    frameSource.hash = uuid;
    return frameSource;
};
const $35c611973a530206$export$28ca0294113407cf = (config)=>{
    const frame = document.createElement("iframe");
    const frameSource = $35c611973a530206$var$buildFrameSource(config);
    frame.setAttribute("src", frameSource.toString());
    frame.style.setProperty("border", "none");
    return frame;
};





const $dd337cf352ccf565$var$FALLBACK_ERROR_MESSAGE = "Something went wrong. Please try again or contact support.";
const $dd337cf352ccf565$var$createRouteError = (onPinEntryError, onTokenizeCardError)=>(error)=>{
        onTokenizeCardError?.(error);
        onPinEntryError?.(error);
    };
const $dd337cf352ccf565$export$221b191fcfaf22a = ({ uuid: uuid, onPinEntryError: onPinEntryError, onInput: onInput, onPinEntrySuccess: onPinEntrySuccess, onTokenizeCardSuccess: onTokenizeCardSuccess, onStateChange: onStateChange, onReady: onReady, onTokenizeCardError: onTokenizeCardError })=>(event)=>{
        if (event.origin !== (0, $219e08b0dbf8e45a$export$f76cea9319723dd2) || uuid !== event.data.uuid) return false;
        const { data: data } = event.data;
        const routeError = $dd337cf352ccf565$var$createRouteError(onPinEntryError, onTokenizeCardError);
        switch(data.__typename){
            case (0, $e4bfc9dfdbfc25a2$export$5278e3e6401288b4).INVALID_CREDENTIAL_ERROR:
                routeError({
                    name: "InvalidCredentialError",
                    context: data.context
                });
                break;
            case (0, $e4bfc9dfdbfc25a2$export$5278e3e6401288b4).ON_PIN_CHANGE_SUCCESS:
                onPinEntrySuccess?.(data.field);
                break;
            case (0, $e4bfc9dfdbfc25a2$export$5278e3e6401288b4).ON_TOKENIZE_CARD_SUCCESS:
                onTokenizeCardSuccess?.(data.paymentMethodToken);
                break;
            case (0, $e4bfc9dfdbfc25a2$export$5278e3e6401288b4).ON_STATE_CHANGE:
                onStateChange?.(data.field, data.state);
                break;
            case (0, $e4bfc9dfdbfc25a2$export$5278e3e6401288b4).ON_INPUT:
                onInput?.(data.field, data.config);
                break;
            case (0, $e4bfc9dfdbfc25a2$export$5278e3e6401288b4).ON_READY:
                onReady?.();
                break;
            case (0, $e4bfc9dfdbfc25a2$export$5278e3e6401288b4).USER_INPUT_ERROR:
                {
                    const { field: field, message: message } = data;
                    const error = {
                        name: "SecureInputsFieldInputError",
                        field: field,
                        message: message
                    };
                    onPinEntryError?.(error);
                    break;
                }
            case (0, $e4bfc9dfdbfc25a2$export$5278e3e6401288b4).REQUEST_ERROR:
                {
                    const { field: field, message: message, context: context } = data;
                    routeError({
                        name: "SecureInputsRequestError",
                        field: field,
                        message: message,
                        context: context
                    });
                    break;
                }
            case (0, $e4bfc9dfdbfc25a2$export$5278e3e6401288b4).GENERIC_ERROR:
                routeError({
                    name: "Error",
                    message: data.message
                });
                break;
            case (0, $e4bfc9dfdbfc25a2$export$5278e3e6401288b4).VALIDATION_ERROR:
                {
                    // Only the card frame posts this, so only the tokenization path hears
                    // it; the pin path's onError never receives a validation error.
                    const { message: message, invalidFields: invalidFields, unavailableFields: unavailableFields, fields: fields } = data;
                    onTokenizeCardError?.({
                        name: "SecureInputsValidationError",
                        message: message,
                        invalidFields: invalidFields,
                        unavailableFields: unavailableFields,
                        fields: fields
                    });
                    break;
                }
            default:
                routeError({
                    name: "Error",
                    message: $dd337cf352ccf565$var$FALLBACK_ERROR_MESSAGE
                });
                break;
        }
        return true;
    };




const $f4845008db431c85$var$FAILURE_MESSAGES = {
    FRAME_UNREACHABLE: "Unable to reach the secure inputs frame. Please try again or contact support.",
    HANDSHAKE_TIMEOUT: "Secure inputs frame did not respond. Please try again or contact support."
};
const $f4845008db431c85$export$33761465198c517e = ({ frame: frame, uuid: uuid, clientToken: clientToken, paymentCardId: paymentCardId, onError: onError, onHandshakeAck: onHandshakeAck })=>(0, $9811ef52d0caa509$export$84683bda827d284f)({
        frame: frame,
        iframeOrigin: $219e08b0dbf8e45a$export$f76cea9319723dd2,
        uuid: uuid,
        clientToken: clientToken,
        paymentCardId: paymentCardId,
        sdkName: (0, $219e08b0dbf8e45a$export$9345d7360ffe0722),
        sdkVersion: (0, $219e08b0dbf8e45a$export$91546b032799aa40),
        onHandshakeAck: onHandshakeAck,
        onFailure: (failure)=>{
            onError({
                name: "SecureInputsHandshakeError",
                message: $f4845008db431c85$var$FAILURE_MESSAGES[failure]
            });
        }
    });


const $597ed8cd77b80d65$var$unmount = (fields)=>{
    Object.values(fields).forEach((field)=>{
        if (field) {
            // Tear down the handshake first so no pending timer can call onError
            // after the frames are gone.
            field.disposeSecureChannel?.();
            field.container.replaceChildren("");
        }
    });
};
const $597ed8cd77b80d65$var$submit = (fieldName, field, event)=>{
    const targetWindow = field?.frame.contentWindow;
    if (targetWindow === null || targetWindow === undefined) return {
        name: "SecureInputsSubmitError",
        message: `Unable to submit field: ${fieldName}`
    };
    targetWindow.postMessage(event, (0, $219e08b0dbf8e45a$export$f76cea9319723dd2));
    return undefined;
};
const $597ed8cd77b80d65$var$generateFields = ({ uuid: uuid, elements: elements, clientToken: clientToken, environment: environment, excludedCardBrands: excludedCardBrands, onError: onError, onHandshakeAck: onHandshakeAck })=>{
    const fields = Object.keys(elements).map((element)=>element);
    const fieldMap = (0, $e4bfc9dfdbfc25a2$export$1ec34c2c9b231c0f).reduce((accum, field)=>{
        const elementConfig = elements[field];
        if (!elementConfig || typeof elementConfig !== "object" || !("selector" in elementConfig)) return accum;
        const config = elementConfig;
        const frame = (0, $35c611973a530206$export$28ca0294113407cf)({
            uuid: uuid,
            field: field,
            environment: environment,
            fields: fields,
            excludedCardBrands: excludedCardBrands,
            elementConfig: {
                [field]: elementConfig
            }
        });
        const container = document.querySelector(config.selector) ?? document.body;
        const disposeSecureChannel = field === "pin" || field === "cardNumber" ? (0, $f4845008db431c85$export$33761465198c517e)({
            frame: frame,
            uuid: uuid,
            clientToken: clientToken,
            onError: onError,
            onHandshakeAck: onHandshakeAck,
            ...field === "pin" ? {
                paymentCardId: elementConfig.paymentCardId ?? ""
            } : {}
        }) : undefined;
        container.append(frame);
        return {
            ...accum,
            [field]: {
                frame: frame,
                container: container,
                disposeSecureChannel: disposeSecureChannel
            }
        };
    }, {
        pin: undefined,
        cardNumber: undefined,
        expirationYear: undefined,
        expirationDate: undefined,
        expirationMonth: undefined,
        securityCode: undefined
    });
    return fieldMap;
};
const $597ed8cd77b80d65$var$renderTokenizationFields = async ({ onStateChange: onStateChange, onSuccess: onSuccess, onError: onError, onReady: onReady, elements: elements, clientToken: clientToken, environment: environment = "test", excludedCardBrands: excludedCardBrands = [] })=>{
    const uuid = (0, $219e08b0dbf8e45a$export$1c3aefb711c3a4cc)();
    // Dedupe the parent timeout and the iframe's relayed configure-timeout at
    // their convergence on onError (see HandshakeGate). This path establishes
    // exactly one credentialed channel (cardNumber), so the shared failure latch
    // is driven by a single handshake.
    const gate = (0, $9811ef52d0caa509$export$d572882ed38b887b)();
    const relayError = gate.wrapRelay(onError);
    const fields = $597ed8cd77b80d65$var$generateFields({
        uuid: uuid,
        elements: elements,
        clientToken: clientToken,
        environment: environment,
        excludedCardBrands: excludedCardBrands,
        onError: gate.wrapFailure(onError),
        onHandshakeAck: gate.ack
    });
    window.removeEventListener("message", (0, $dd337cf352ccf565$export$221b191fcfaf22a)({
        uuid: uuid,
        onTokenizeCardError: relayError,
        onTokenizeCardSuccess: onSuccess,
        onStateChange: onStateChange,
        onReady: onReady
    }));
    window.addEventListener("message", (0, $dd337cf352ccf565$export$221b191fcfaf22a)({
        uuid: uuid,
        onTokenizeCardError: relayError,
        onTokenizeCardSuccess: onSuccess,
        onStateChange: onStateChange,
        onReady: onReady
    }));
    return {
        submit: (args)=>{
            const { additionalData: additionalData } = args ?? {};
            return $597ed8cd77b80d65$var$submit("cardNumber", fields.cardNumber, {
                __typename: (0, $e4bfc9dfdbfc25a2$export$5278e3e6401288b4).TOKENIZE_CARD,
                additionalData: additionalData
            });
        },
        unmount: async ()=>{
            $597ed8cd77b80d65$var$unmount(fields);
        }
    };
};
const $597ed8cd77b80d65$var$renderFieldsForPinEntry = async ({ onSuccess: onSuccess, onInput: onInput, onError: onError, elements: elements, clientToken: clientToken, environment: environment = "test" })=>{
    const uuid = (0, $219e08b0dbf8e45a$export$1c3aefb711c3a4cc)();
    // See renderTokenizationFields: one gate per render path dedupes the parent
    // timeout and the iframe's relayed configure-timeout at their convergence on
    // onError, releasing all relayed errors once the ACK has been received. This
    // path establishes exactly one credentialed channel (pin), so the gate's
    // shared failure latch is driven by a single handshake.
    const gate = (0, $9811ef52d0caa509$export$d572882ed38b887b)();
    const relayError = gate.wrapRelay(onError);
    const fields = $597ed8cd77b80d65$var$generateFields({
        uuid: uuid,
        elements: elements,
        clientToken: clientToken ?? elements.pin.clientToken ?? "",
        environment: environment,
        onError: gate.wrapFailure(onError),
        onHandshakeAck: gate.ack
    });
    window.removeEventListener("message", (0, $dd337cf352ccf565$export$221b191fcfaf22a)({
        uuid: uuid,
        onInput: onInput,
        onPinEntryError: relayError,
        onPinEntrySuccess: onSuccess
    }));
    window.addEventListener("message", (0, $dd337cf352ccf565$export$221b191fcfaf22a)({
        uuid: uuid,
        onInput: onInput,
        onPinEntryError: relayError,
        onPinEntrySuccess: onSuccess
    }));
    return {
        submit: ()=>$597ed8cd77b80d65$var$submit("pin", fields.pin, {
                __typename: (0, $e4bfc9dfdbfc25a2$export$5278e3e6401288b4).CHANGE_CARD_PIN
            }),
        unmount: async ()=>{
            $597ed8cd77b80d65$var$unmount(fields);
        }
    };
};
const $597ed8cd77b80d65$var$isClientTokenDefined = (config)=>config.clientToken !== undefined || "pin" in config.elements && config.elements.pin.clientToken !== undefined;
const $597ed8cd77b80d65$export$214cd789bf36dbe8 = async (config)=>{
    if (!$597ed8cd77b80d65$var$isClientTokenDefined(config)) throw new Error("clientToken was undefined");
    return await $597ed8cd77b80d65$var$renderTokenizationFields(config);
};
const $597ed8cd77b80d65$export$1b4461fdcf0903a6 = async (config)=>{
    if (!$597ed8cd77b80d65$var$isClientTokenDefined(config)) throw new Error("clientToken was undefined");
    return await $597ed8cd77b80d65$var$renderFieldsForPinEntry(config);
};


//# sourceMappingURL=index.js.map
